import { toJS } from "mobx";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import PDFICON from "../../../src/assets/Home/PDFICON.svg";

import View from "../../assets/view.svg";
import DeleteIcon from "../../assets/Delete.svg";

type Obj = {
  [key: string]: any;
};

interface NOCMobileDataGridProps {
  rows: Obj[];
  indexes: any;
  handlePDCModalOpen: any;
  handlePay: any;
  handleSocialCaseModalOpen: any;
  downloadBillPDF: any;
  handleCancelRequest?: any;
  handleUpdateMovein?: any;
}

const NOCMobileDataGrid: React.FC<NOCMobileDataGridProps> = ({
  rows,
  indexes,
  handlePDCModalOpen,
  handlePay,
  handleSocialCaseModalOpen,
  downloadBillPDF,
  handleCancelRequest,
  handleUpdateMovein
}) => {
  const contrast = General?.contrast;

  return (
    <div
      className="px-3 "
      style={{
        height: "20rem",
        overflowY: "scroll",
        backgroundColor: "white",
        position: "relative",
      }}
    >
      {indexes === 0 && (
        <div>
          {rows.map((rows, index) => {
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      Ref Number
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.refNumber}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Sewerage Number
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>
                  <div className="py-1"></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Submission Date
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.submissionDate}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Request Type
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.requestType}{" "}
                    </p>
                  </div>
                  <div className=""></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_accountnopaymentstable"]?.label
                        ? General?.codeLabels["cm_accountnopaymentstable"]
                            ?.label
                        : "Account Number"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Download
                    </p>

                      <img src={PDFICON} 
                      onClick={() => downloadBillPDF(rows.id.toString(),rows.refNumber)}                        
                      alt="pdf" />
                  </div>
                  <div className=""></div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}

      {indexes === 1 && (
        <div>
          {rows.map((rows, index) => {
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      Ref Number
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.refNumber}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Sewerage Number
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>
                  <div className="py-1"></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Submission Date
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.submissionDate}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Request Type
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.statusDescription}{" "}
                    </p>
                  </div>
                  <div className=""></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_accountnopaymentstable"]?.label
                        ? General?.codeLabels["cm_accountnopaymentstable"]
                            ?.label
                        : "Account Number"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>
{/* 
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Download
                    </p>

                    <a href={rows.nocReceipt} target="_blank">
                      <img src={PDFICON} alt="" />
                    </a>
                  </div> */}
                  <div className="">
                    
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Actions
                    </p>

                    {rows.requestType === "MOVEIN" ? (
                      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
    {/* 1. Cancel Request Button Logic */}
    {(rows?.cancellable && (rows?.status === "HOLD-CUSTACT" || !rows?.userAssigned)) && (
      <button
        style={{
          padding: "6px 10px",
          background: "#101e8e",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
          whiteSpace: "nowrap", // Fixes the wrap issue from your image
          height: "34px",
          minWidth: "110px"
        }}
        onClick={() => handleCancelRequest?.(rows.refNumber)}
      >
        {General?.codeLabels["cm_cancel_request"]?.label || "Cancel Request"}
      </button>
    )}

    {/* 2. View Details Button Logic */}
    {(rows?.status === "HOLD-CUSTACT" || rows?.status === "HOLD-FLDINSP" || rows?.status === "REJECTED") && (
      <button
        style={{
          padding: "6px 10px",
          background: "#101e8e",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
          whiteSpace: "nowrap",
          height: "34px",
          minWidth: "110px"
        }}
        onClick={() => handleUpdateMovein?.(rows.refNumber)}
      >
        {General?.codeLabels["cm_view_details"]?.label || "View Details"}
      </button>
    )}
  </div>
                    ) : rows.requestType === "MVOUTDISPUTE" || rows.requestType === "OUT NOC" || rows.requestType === "MOVEOUTAPPRV" ? (
                      rows?.cancellable ? (
                        <button
                          style={{
                            padding: "6px 16px",
                            background: "#101e8e",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                            height: "auto",
                            width: "auto",
                          }}
                          onClick={() => handleCancelRequest?.(rows.refNumber)}
                        >
                          {General?.codeLabels["cm_cancel_request"]?.label ? General?.codeLabels["cm_cancel_request"]?.label : "Cancel Request"}
                        </button>
                      ) : null
                    ) : rows?.status === "WAITPAYMENT" || rows?.status === "WaitPayment" ? (
                      <button
                        style={{
                          padding: "6px 16px",
                          background: "#101e8e",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "14px",
                          height: "auto",
                          width: "auto",
                        }}
                        onClick={() => window.location.href = `/getdispute/${rows?.refNumber}`}
                      >
                        Go to payment
                      </button>
                    ) : null
                    // (
                    //   <button
                    //     style={{
                    //       padding: "6px 16px",
                    //       background: "#101e8e",
                    //       color: "#fff",
                    //       border: "none",
                    //       borderRadius: "4px",
                    //       cursor: "pointer",
                    //       fontSize: "14px",
                    //       height: "auto",
                    //       width: "auto",
                    //     }}
                    //     onClick={() => handleUpdateMovein?.(rows.refNumber)}
                    //   >
                    //     {General?.codeLabels["cm_view_details"]?.label ? General?.codeLabels["cm_view_details"]?.label : "View Details"}
                    //   </button>
                    // )
                    }
                  </div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}

      {indexes === 2 && (
        <div>
          {rows.map((rows, index) => {
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {General?.codeLabels["cm_pdc_paymentplanid"]?.label
                        ? General?.codeLabels["cm_pdc_paymentplanid"]?.label
                        : "Payment Plan ID"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.paymentPlanID}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_asreqstatustable"]?.label
                        ? General?.codeLabels["cm_asreqstatustable"]?.label
                        : "Status"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.status}{" "}
                    </p>
                  </div>
                  <div className="py-1"></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_created_on"]?.label
                        ? General?.codeLabels["cm_created_on"]?.label
                        : "Created On"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.createdOn}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_pdc_amountinaed"]?.label
                        ? General?.codeLabels["cm_pdc_amountinaed"]?.label
                        : "Amount(AED)"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.amount}{" "}
                    </p>
                  </div>
                  <div className=""></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_billsnumberpdctable"]?.label
                        ? General?.codeLabels["cm_billsnumberpdctable"]?.label
                        : "Number of Cheques"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.numberOfCheques}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_label_appointment_actions"]
                        ?.label
                        ? General?.codeLabels["cm_label_appointment_actions"]
                            ?.label
                        : "Actions"}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "30%",
                        gap: "20px",
                      }}
                    >
                      <img
                        src={View}
                        alt="View"
                        onClick={() => handlePDCModalOpen(rows.paymentPlanID)}
                        style={{ cursor: "pointer" }}
                      />

                      {rows.status === "Payment Pending" ||
                      rows.status === "Created" ? (
                        <img
                          src={DeleteIcon}
                          alt="delete"
                          onClick={() => alert("")}
                          style={{ cursor: "pointer" }}
                        />
                      ) : null}
                      <button style={{ fontSize: `${General.accessibility.fontSize}rem`, border: "1px solid rgb(16, 30, 142)", color: contrast?.contrastColor ? contrast?.contrastColor : "rgb(16, 30, 142)", background: contrast?.contrastBackground ? contrast?.contrastBackground : "white", padding: "2px 20px" ,marginLeft:'5px'}} onClick={() => handlePay(rows?.paymentPlanID)}>{General?.codeLabels["cm_pay"]?.label ? General?.codeLabels["cm_pay"]?.label : "Pay"}</button>
                    </div>
                  </div>
                  <div className=""></div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}

      {indexes === 3 && (
        <div>
          {rows.map((rows, index) => {
            console.log("rows 3", toJS(rows));
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {General?.codeLabels["cm_date"]?.label
                        ? General?.codeLabels["cm_date"]?.label
                        : "Date"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.date}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_total_due_amount"]?.label
                        ? General?.codeLabels["cm_total_due_amount"]?.label
                        : "Total Due"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.totalDue}{" "}
                    </p>
                  </div>
                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_label_appointment_actions"]
                        ?.label
                        ? General?.codeLabels["cm_label_appointment_actions"]
                            ?.label
                        : "Actions"}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "30%",
                      }}
                    >
                      <img
                        src={View}
                        alt="View"
                        onClick={() =>
                          handleSocialCaseModalOpen(rows.requestNumber)
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_requestno"]?.label
                        ? General?.codeLabels["cm_requestno"]?.label
                        : "DaRequest Numberte"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.requestNumber}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_approvedamount"]?.label
                        ? General?.codeLabels["cm_approvedamount"]?.label
                        : "Approved Amount"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.approvedAmount}{" "}
                    </p>
                  </div>
                  <div className="">
                    {/* <p
                className="mb-0 account-grid-mobile-heading"
                style={{
                  fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {General?.codeLabels["cm_accountnopaymentstable"]?.label
                  ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                  : "Account Number"}
              </p>
              <p
                className="mb-0 account-grid-mobile-text"
                style={{
                  fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {rows.accountNumber}{" "}
              </p> */}
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_parcelnumber"]?.label
                        ? General?.codeLabels["cm_parcelnumber"]?.label
                        : "cm_parcelnumber"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.parcelNumber}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_asreqstatustable"]?.label
                        ? General?.codeLabels["cm_asreqstatustable"]?.label
                        : "Status"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.status}{" "}
                    </p>
                  </div>
                  <div className="">
                    {/* <p
                className="mb-0 account-grid-mobile-heading"
                style={{
                  fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {General?.codeLabels["cm_accountnopaymentstable"]?.label
                  ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                  : "Account Number"}
              </p>
              <p
                className="mb-0 account-grid-mobile-text"
                style={{
                  fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {rows.accountNumber}{" "}
              </p> */}
                  </div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default observer(NOCMobileDataGrid);
